import axios, { AxiosRequestConfig } from 'axios';

interface IAxiosConfig extends AxiosRequestConfig {
  contentType?: string;
  headers: optionalHeadersValues;
}

interface optionalHeadersValues {
  applicationId?: string;
  subscriptionKey?: string;
}

const axiosCall = async ({
  url,
  data,
  method,
  contentType,
  headers,
}: IAxiosConfig) => {
  const result = await axios({
    url,
    method: method || 'GET',
    data,
    // Receive/send the HttpOnly access_token cookie (sign in sets it).
    withCredentials: true,
    headers: {
      'Content-type': contentType || 'application/json',
      ...headers,
    },
  });
  
  return result.data;
};

export default axiosCall;
